import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jwmFeedbackNudgeContentSpork: {
		id: 'software-onboarding-nudges--next.jwm-feedback.jwm-feedback-nudge-content-spork',
		defaultMessage: 'Give us your feedback here.',
		description:
			'Nudge content that will show up to new users when users click on find help and get feedback checklist item in quickstart. This Nudge guides the user to learn more about finding help and leaving feedback.',
	},
	nudgeCtaFinish: {
		id: 'software-onboarding-nudges--next.jwm-feedback.nudge-cta-finish',
		defaultMessage: 'Finish',
		description:
			'This is the text that is on a button in the nudge to indicate the user is finished with the current sequence.',
	},
});
